var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 2.25v19.5h15V7.2l-.23-.22-4.5-4.5-.22-.23zM6 3.75h7.5v4.5H18v12H6zm9 1.05 1.95 1.95H15zm-3.75 4.95v3.75H9l3 3 3-3h-2.25V9.75zM9 17.25v1.5h6v-1.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownload2);
export default ForwardRef;